import { MenuItem } from './MainMenu';
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { Graph } from '../../generated/graph';
import { Permission } from '../Permission';

type Props = {
  items: MenuItem[]
}

export class ResponsiveMenu extends React.Component<Props> {
  state: {
    activeItem?: MenuItem
  } = {};

  timerMenuLeavingID?: NodeJS.Timeout;

  public render() {
    return (
      <UserContext.Consumer>
        { (context) => (
          <div className='menu-w color-scheme-light color-style-transparent menu-position-side menu-side-left menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link'>
            { this.props.children }
            <div className='menu-and-user'>
              <ul className='main-menu has-active'>
                { this.props.items.map(item => this.renderMenu(context.user as Graph.User, item)) }
              </ul>
            </div>
          </div>
        )}
      </UserContext.Consumer>
    );
  }

  private renderSubmenuItem(user: Graph.User, item: MenuItem) {
    return (
      <Permission key={item.name} permission={item.permission} permissionsAny={item.permissionsAny} permissionsMust={item.permissionsMust}>
        <li 
        key={item.name}
          onClick={ this.onClick.bind(this, item) }
        >
          <Link to={item.to}><i className={ item.icon }></i> { item.name }</Link>
        </li>
      </Permission>
    )
  }

  private renderSubmenuItems(user: Graph.User, items: MenuItem[], index: number) {
    return (
      <ul key={ index} className='sub-menu'>
        { items.map(subItem => this.renderSubmenuItem(user, subItem)) }
      </ul>
    )
  }

  private renderSubmenu(user: Graph.User, item: MenuItem) {
    if (!item.subs) return;
    if (item.subs.length === 0) return;

    let subs: ReactNode;
    if (Array.isArray(item.subs[0])) {
      subs = (item.subs as MenuItem[][]).map((x, index) => this.renderSubmenuItems(user, x, index)) 
    } else {
      subs = this.renderSubmenuItems(user, item.subs as MenuItem[], 0);
    }
    
    return (
      <div className='sub-menu-w'>
        <div className='sub-menu-header'>{ item.name }</div>
        <div className='sub-menu-icon'>
          <i className={ item.icon }></i>
        </div>
        <div className='sub-menu-i'>
          { subs }
        </div>
      </div>
    )
  }

  private renderMenu(user: Graph.User, item: MenuItem) {
    let classNameList: string[] = [];
    
    if (item.subs && item.subs.length > 0) {
      classNameList.push('has-sub-menu');
    }

    if (this.state.activeItem === item) {
      classNameList.push('active')
    }

    if (item.header) {
      return (
        <Permission key={item.name} permission={item.permission} permissionsAny={item.permissionsAny} permissionsMust={item.permissionsMust}>
          <li key={item.name} className='sub-header font-weight-bold'>
            <span>{ item.name }</span>
          </li>
        </Permission>
      );
    } else {
      return (
        <Permission key={item.name} permission={item.permission} permissionsAny={item.permissionsAny} permissionsMust={item.permissionsMust}>
          <li
            key={item.name}
            className={ classNameList.join(' ') }
            onMouseEnter={ this.onMouseEnter.bind(this, item) }
            onMouseLeave={ this.onMouseLeave.bind(this, item) }
            onClick={ this.onClick.bind(this, item) }
          >
            <Link to={ item.to }>
                <div className="icon-w">
                  <i className={ item.icon }></i>
                </div>
                <span>{ item.name }</span>
            </Link>
            { this.renderSubmenu(user, item) }
          </li>
        </Permission>
      );
    }
  }

  private onMouseEnter(item: MenuItem) {
    if(window.innerWidth > 768) {
      if (this.state.activeItem !== item) {
        if (this.timerMenuLeavingID) clearTimeout(this.timerMenuLeavingID);
        this.setState({ activeItem: item });
      }
    }
  }

  private onMouseLeave(item: MenuItem) {
    if(window.innerWidth > 768) {
      if (this.state.activeItem === item) {
        this.timerMenuLeavingID = setTimeout(() => {
          this.setState({ activeItem: null });
        }, 30);
      }
    }
  }


  private onClick = (item: MenuItem) => {
    if(window.innerWidth <= 768) {
      if(item.to === "#") {
        if (this.state.activeItem === item) {
          this.setState({ activeItem: null });
        } else {
          this.setState({ activeItem: item });
        }
      } else {
        document.querySelector(".menu-w")!.classList.toggle("show");
      }
    }

    if(item.to !== "#") { 
      window.scrollTo(0, 0);
    }
  }
}